type PageHeaderType = {
  headerName?: string;
  description?: string;
  children?: React.ReactNode;
};

export default function PageHeader({
  headerName = 'Prompt Library',
  description = '',
  children = null
}: PageHeaderType) {
  return (
    <div>
      <div className="h4 un_standard_color" style={{ margin: 0 }}>
        {children}
        {headerName}
      </div>
      <p className="h5_400" style={{ fontWeight: 400, color: 'var(--grey_tone)' }}>
        {description}
      </p>
    </div>
  );
}
